import React from 'react';
import 'styles/components/menu/research/SupportToolTab.scss';
import configurationData from 'assets/data/configuration.json';
import systemLinkData from 'assets/data/systemLink.json';
import styled from 'styled-components';
import configuration from 'assets/images/research/configuration.png';
import systemLink from 'assets/images/research/systemLink.png';

const Img = styled.div`
    width: 100%;
    height: 0;
    padding-top: calc(${props => props.height} / ${props => props.width} * 100%);
    background : url(${props => props.src}) center left / cover no-repeat;
    margin-bottom: 2rem;
`;

const SupportToolTab = () => {
    return (
        <section className='SupportToolTab'>
            <div className="SupportToolTab-wrapper">
                <div className="title">
                    <span className='fw_bold'>산출물 자동화 및 테스트 지원도구</span> 등
                    <br className='lineBreak' />
                    {" "}업무에<br className='lineBreak pc' /> 필요한 툴을
                    <br className='lineBreak' />
                    <span className='fw_bold'> 직접 제작하여 활용</span>하고 있습니다
                </div>
                <div className="content">
                    <div className="content-title">산출물 자동화 생성 툴</div>
                    <div className="content-text">
                        {configurationData.map((item, idx) => <p key={idx}>{item}</p>)}
                    </div>
                    <div className="content-img">
                        <Img src={configuration} width={1491} height={859} />
                    </div>
                </div>
                <div className="content">
                    <div className="content-title">타 체계(시스템) 연동 모의기</div>
                    <div className="content-text">
                        {systemLinkData.map((item, idx) => <p key={idx}>{item}</p>)}
                    </div>
                    <div className="content-img">
                        <Img src={systemLink} width={1614} height={744} />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SupportToolTab;